<template>
  <slot v-bind="{ ...$attrs, isHidden, rect }" />
</template>

<script setup lang="ts">
defineComponent({
  inheritAttrs: false,
});

type ToMutable<T extends object> = { -readonly [Key in keyof T]: T[Key] };
type MutableDOMRect = Omit<ToMutable<DOMRect>, "toJSON">;

const isHidden = inject<ComputedRef<boolean>>(
  "overlayIsHidden",
  computed(() => true),
);
const rect = inject<Ref<MutableDOMRect>>(
  "overlayRect",
  ref({
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  }),
);

defineExpose<{
  isHidden: Ref<boolean>;
  rect: Ref<MutableDOMRect>;
}>({ isHidden, rect });
</script>
